<template>
    <DeleteModal
        :visible.sync="showModal"
        :is-loading="isLoading"
        :is-submiting="isSubmiting"
        :disabled="!id"
        description="Deseja realmente excluir esta notificação? Esta ação não poderá ser desfeita."
        @cancel="toggleModal"
        @confirm="onSubmit"
        @closed="resetModal"
    >
        <div v-if="notificacao" class="d-flex align-items-center">
            <i class="el-icon-bell"></i>
            <span class="font-weight-bold ml-2">{{ notificacao.title }}</span>
        </div>
    </DeleteModal>
</template>
<script>
    // Components
    import { Notification } from "element-ui";

    import DeleteModal from "@/components/_micro/modals/DeleteModal.vue";

    // Api
    import { NotificacaoApi } from "@/api/NotificacaoApi";

    const notificacaoApi = new NotificacaoApi();

    export default {
        data() {
            return {
                id: null,
                notificacao: null,
                showModal: false,
                isLoading: false,
                isSubmiting: false,
            }
        },
        methods: {
            async show() {
                try {
                    this.isLoading = true;

                    const res = await notificacaoApi.show(this.id);

                    this.notificacao = res?.data ?? res;
                } catch (err) {
                    Notification.error({
                        title: 'Erro',
                        message: 'Não foi possível obter a notificação! Algo inesperado ocorreu.'
                    });
                } finally {
                    this.isLoading = false;
                }
            },
            async onSubmit() {
                if (!this.id) return;

                this.isSubmiting = true;

                try {
                    await notificacaoApi.destroy(this.id);

                    Notification.success({
                        title: 'Sucesso',
                        message: 'Notificação excluída com sucesso!'
                    });

                    this.$emit('deleted');
                } catch (error) {
                    Notification.error({
                        title: 'Erro',
                        message: 'Não foi possível excluir a notificação!'
                    });
                } finally {
                    this.isSubmiting = false;
                    this.toggleModal();
                }
            },
            /**Modal */
            toggleModal() {
                this.showModal = !this.showModal;
            },
            resetModal() {
                this.id = null;
                this.notificacao = null;
            },
        },
        components: {
            DeleteModal,
        },
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/_macro/notificacao/NotificacaoDeleteModal.vue